import { createContext, useContext, useState, useEffect } from "react";
import config from "../../../config";
import API from "../../../axios/API";

const CreativePreviewImageContext = createContext(null);

const PreviewImage = ({ children }) => {
  const [previewImage, setPreviewImage] = useState();
  const [imgHeadLine, setImageHeadline] = useState("");
  const [brandText, setBrandText] = useState("");
  const [adName, setAdName] = useState("");
  const [adButtonText, setAdButtonText] = useState("");

  const [saveData, setSaveData] = useState();
  const [toggleUpdateButton, setToggleUpdateButton] = useState(false);

  const [creativeEdit, setCreativeEdit] = useState(0);
  const [updatedJSON, setUpdatedJSON] = useState({});

  let [previewValueAdCopyShow, setPreviewValueAdCopyShow] = useState();
  let [updatePreviewValues, setUpdatePreviewValues] = useState();

  const [creativeActiveStep, setCreativeActiveStep] = useState(0);
  const [fetchByCampaings, setFetchByCampaings] = useState(0);
  const [campaignValue, setCampaignValue] = useState(false);
  const [showCarousel, setShowCarousel] = useState(false);
  const [showPreviewValues, setShowPreviewValues] = useState(false);
  const [addedHeadLineLanguage, setAddedHeadLineLanguage] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [creativeAdCopy, setCreativeAdCopy] = useState(null);
  const [selectedBrand, setSelectedBrand] = useState(0);
  const [RichMediaPreviewValue, setRichMediaPreviewValue] = useState("");
  const [cuboidPreview, setCuboidPreview] = useState("");
  const [selectedCuboidFace, setSelectedCuboidFace] = useState(null);

  // Fetch from Campaign

  const [addCarouselData, setAddCarouselData] = useState();

  const [fetchByAccountFromCampaign, setFetchByAccountFromCampaign] =
    useState(0);

  const [fetchByBrandFromCampaign, setFetchByBrandFromCampaign] = useState(0);

  const [campaignToCreativeAdCopy, SetCampaignToCreativeAdCopy] = useState(0);

  const [selectAccountView, setSelectAccountView] = useState({
    label: "All",
    value: 0,
  });

  let [selectBrandView, setSelectBrandView] = useState();

  let [selectedAccount, setSelectedAccount] = useState(0);

  const [hideShowToggle, setHideShowToggle] = useState(true);

  useEffect(() => {
    if (campaignToCreativeAdCopy > 0) {
      const fetchCreativesByCampaings = async () => {
        const response = await API.post(
          `${config.baseUrl}/creativeservice/creative/creativebyid`,
          campaignToCreativeAdCopy,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data) {
          setCreativeAdCopy(response.data);
        }
      };
      fetchCreativesByCampaings();
    }
  }, [campaignToCreativeAdCopy]);

  return (
    <CreativePreviewImageContext.Provider
      value={{
        previewImage,
        setPreviewImage,
        imgHeadLine,
        adName,
        setAdName,
        setImageHeadline,
        brandText,
        setBrandText,
        adButtonText,
        setAdButtonText,
        saveData,
        setSaveData,
        toggleUpdateButton,
        setToggleUpdateButton,
        creativeEdit,
        setCreativeEdit,
        updatedJSON,
        setUpdatedJSON,
        previewValueAdCopyShow,
        setPreviewValueAdCopyShow,
        creativeActiveStep,
        setCreativeActiveStep,
        fetchByCampaings,
        setFetchByCampaings,
        campaignValue,
        setCampaignValue,
        showCarousel,
        setShowCarousel,
        showPreviewValues,
        setShowPreviewValues,
        addedHeadLineLanguage,
        setAddedHeadLineLanguage,
        activeIndex,
        setActiveIndex,
        campaignToCreativeAdCopy,
        SetCampaignToCreativeAdCopy,
        creativeAdCopy,
        setCreativeAdCopy,
        updatePreviewValues,
        setUpdatePreviewValues,
        fetchByAccountFromCampaign,
        setFetchByAccountFromCampaign,
        fetchByBrandFromCampaign,
        setFetchByBrandFromCampaign,
        addCarouselData,
        setAddCarouselData,
        selectAccountView,
        setSelectAccountView,
        selectBrandView,
        setSelectBrandView,
        selectedAccount,
        setSelectedAccount,
        selectedBrand,
        setSelectedBrand,
        RichMediaPreviewValue,
        setRichMediaPreviewValue,
        hideShowToggle,
        setHideShowToggle,
        cuboidPreview,
        setCuboidPreview,
        selectedCuboidFace,
        setSelectedCuboidFace,
      }}
    >
      {children}
    </CreativePreviewImageContext.Provider>
  );
};

export { PreviewImage, CreativePreviewImageContext };
